import { PremiumLevel } from 'common/types/models';

export const UserLevelTitles = {
    [PremiumLevel.None]: 'Default',
    [PremiumLevel.Premium]: 'A-List',
};

